import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from "../ChemEdit";
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

class RoleType extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			roleType: {
				TYPE_ID: null,
				TYPE_NAME: '',
				TYPE_ABV: '',
				COMMENTS: '',
				CREATE_DATE: null,
				CREATE_BY: '',
				MODIF_DATE: null,
				MODIF_BY: '',
				DIRECTORY_FLAG: null,
				DELETE_FLAG: null
			},
			renderKey: 0
		}
	}

	componentDidMount() {
		this.loadRoleType();
	}

	loadRoleType(event) {
		var self = this;
		
		if (this.props.params.roleTypeId) {
			this.ajax({
				type: 'post',
				url: this.getConfig().host + '/Home/Search',
				data: { 
					__RequestVerificationToken: this.props.user.antiForgeryToken,
					entity: 'ROLE_TYPES',
					search: { Attribute: 'TYPE_ID', Operator: '=', LongValue: this.props.params.roleTypeId },
					pageNumber: -1,
					pageSize: -1
				}
			}).done(function (data) {
				if (data.Success) {
					if (data.Data.length === 1) {
						var roleType = data.Data[0];
																		
						self.mergeState({
							roleType: roleType,
							renderKey: self.state.renderKey + 1
						}, () => {
							if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
						});
					} else {
						self.showAlert('Role Type Error', data.Data.length + ' role types found for ID ' + self.props.params.roleTypeId);
					}
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});	
		} else {
			this.mergeState({
				roleType: {
					TYPE_ID: '(new)'
				}
			});
		}
	}
		
	onChange(accessor, value) {
		var roleType = this.copyObject(this.state.roleType);
		this.setByAccessor(roleType, accessor, value);
		this.mergeState({ roleType: roleType, renderKey: this.state.renderKey + 1 });
	}
		
	deleteRoleType(event) {
		var self = this;
		
		this.showOKCancel('Confirm Delete Role Type', 'Delete Role Type ' + this.props.params.roleTypeId + '?', (okClicked) => {
			if (okClicked) {
				// prepare role type for deletion
				var roleType = self.copyObject(self.state.roleType);
				roleType.DELETE_FLAG = 'Y';
				roleType.CREATE_DATE = self.dateTimeToMVC(self.getDate(roleType.CREATE_DATE));
				roleType.MODIF_DATE = self.dateTimeToMVC(new Date());
				roleType.MODIF_BY = self.props.user.name;
				
				this.ajax({
					type: 'POST',
					url: self.getConfig().host + '/Home/Update',
					data: { __RequestVerificationToken: self.props.user.antiForgeryToken, entity: 'ROLE_TYPES', data: roleType }
				}).done(function (data) {
					if (data.Success) {
						self.props.parent.showConfirmation(() => {
							return (<>
								Role Type {self.props.params.roleTypeId} deleted.
							</>); 
						});
					} else {
						self.showAlert('Server Error', data.Message);
					}			
				}).fail(function (jqXHR, textStatus, errorThrown) {
					self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
				});
			}
		});
	}
		
	onSubmit(event) {
		var self = this;		
		var dtNow = this.dateTimeToMVC(new Date());
		var currentUser = this.props.user.name;
		
		// make copy of data
		var roleType = this.copyObject(this.state.roleType);
		
		// change directory flag to oracle style
		roleType.DIRECTORY_FLAG = roleType.DIRECTORY_FLAG === 'Yes' ? 'Y' : null;
		
		// if this is a new role type, set ID to sequence name
		var url;
		if (this.props.params.roleTypeId) {
			url = this.getConfig().host + '/Home/Update';
			roleType.CREATE_DATE = this.dateTimeToMVC(this.getDate(roleType.CREATE_DATE));
			roleType.MODIF_DATE = dtNow;
			roleType.MODIF_BY = currentUser;
		} else {
			url = this.getConfig().host + '/Home/Insert';
			roleType.TYPE_ID = null;
			roleType.CREATE_DATE = dtNow;
			roleType.CREATE_BY = currentUser;
			roleType.MODIF_DATE = null;
			roleType.MODIF_BY = null;
			roleType.DELETE_FLAG = null;
		}			
		
		this.ajax({
			type: 'POST',
			url: url,
			data: { __RequestVerificationToken: this.props.user.antiForgeryToken, entity: 'ROLE_TYPES', data: roleType }
		}).done(function (data) {
			if (data.Success) {
				var roleTypeId = self.props.params.roleTypeId ? roleType.TYPE_ID : data.ID;
				var verb = self.props.params.roleTypeId ? 'updated' : 'inserted';
				self.props.parent.showConfirmation(() => {
					return (<>
						Role Type <Link to={'/BuildingAccess/RoleTypes/' + roleTypeId}>{roleTypeId}</Link> {verb}.
					</>);
				});
			} else {
				self.showAlert('Server Error', data.Message);
			}
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}

	render() {
		return (<>
		  <Container fluid>
			<Row>
			  <Col xs={12} style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Role Type {this.state.roleType.TYPE_ID}</div>
				<ChemEdit parent={this} columns={roleTypeColumns} data={this.state.roleType} user={this.props.user} renderKey={this.state.renderKey} 
				   onChange={(accessor, value) => this.onChange(accessor, value)} onSubmit={(event) => this.onSubmit(event)}>
				  <Form.Group>
					<Button id="save" variant="warning" type="submit" className="float-end">Save</Button>
					{this.props.params.roleTypeId && <Button id="delete" variant="warning" type="button" className="float-end"
					  style={{ marginRight: '20px' }} onClick={(event) => this.deleteRoleType(event)}>Delete</Button>} 
				  </Form.Group>
				</ChemEdit>
			  </Col>
			</Row>
		  </Container>
		</>);
	}
}

const roleTypeColumns = [
	{ Header: 'Name', accessor: 'TYPE_NAME', required: true },
	{ Header: 'Abbreviation', accessor: 'TYPE_ABV' },
	{ Header: 'Comments', accessor: 'COMMENTS' },
	{ Header: 'Directory', accessor: 'DIRECTORY_FLAG', type: 'select',
		options: [{ value: 'No', label: 'No' }, { value: 'Yes', label: 'Yes' }]},
	{ Header: 'Last Modified', accessor: 'MODIF_BY', editable: false,
		Cell: props => {
			// if there is no modif date
			if (props.editor.props.data.MODIF_DATE === null)
			{
				// if there is no create date
				if (props.editor.props.data.CREATE_DATE === null)
				{
					// no info to return
					return null;
				} else {
					// use creation date
					return <>{props.parent.dateToString(props.parent.getDate(props.editor.props.data.CREATE_DATE)) + ' ' + props.editor.props.data.CREATE_BY}</>;
				}
			} else {
				return <>{props.parent.dateToString(props.parent.getDate(props.editor.props.data.MODIF_DATE)) + ' ' + props.value}</>;
			}
		}
	},
	{ Header: 'Deleted', accessor: 'DELETE_FLAG', editable: false }
];

export default withRouter(RoleType);
